import * as React from 'react'
import { StyleSheet, Text, View } from 'react-native'
import { Spacer } from '@components/Spacer'
import { primary } from '@themes/Colors'
import Fonts from '@themes/Fonts'
import { CircleImage } from '~/Components/CircleImage/Original'

export function Header(props: {
  text?: string
  image?: string
  children?: React.ReactNode
}) {
  return (
    <View style={styles.container}>
      {props.image && (
        <View
          style={{
            position: 'relative',
            width: 24,
            height: 24,
          }}
        >
          <CircleImage
            image={props.image}
            size={24}
            borderWidth={1}
            borderColor="#e9eaee"
            hideShadow
          />
          <Spacer noShrink width={8} />
        </View>
      )}
      <Text style={styles.text} numberOfLines={1}>
        {props.text}
      </Text>
    </View>
  )
}

const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    marginTop: 10,
    marginBottom: 10,
    justifyContent: 'flex-start',
    alignItems: 'center',
  },
  text: {
    fontFamily: Fonts.type.alternateBold,
    fontWeight: 'bold',
    fontSize: Fonts.size.medium,
    color: primary,
    textTransform: 'uppercase',
  },
})
